import Swiper from 'swiper';
import 'swiper/css';
import { Mousewheel, Keyboard } from 'swiper/modules';
import { debounce } from '../simplerToolkit';

const swiperEventBlocks = document.querySelectorAll('section.events .swiper');

if (swiperEventBlocks.length) {
  swiperEventBlocks.forEach(swiperContainer => {
    const breakpoint = window.matchMedia('(min-width: 1200px)');
    let swiperInstance = null;

    const enableSwiper = () => {
      swiperInstance = new Swiper(swiperContainer, {
        modules: [Mousewheel, Keyboard],
        direction: 'horizontal',
        spaceBetween: 15,
        slidesPerView: 1.2,
        slidesOffsetAfter: 20,

        mousewheel: {
          forceToAxis: true,
          sensitivity: 1,
        },

        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },

        breakpoints: {
          550: {
            slidesPerView: 1.5,
            spaceBetween: 25,
          },
          720: {
            slidesPerView: 2.15,
            spaceBetween: 20,
          },
          890: {
            slidesPerView: 2.5,
          },
            1100: {
            slidesPerView: 2.75,
          },
        },
      });
    };

    const destroySwiper = () => {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    };

    const clampDescriptions = () => {
      swiperContainer.querySelectorAll('.event-card').forEach(card => {
        const description = card.querySelector('.event-description');
        const image = card.querySelector('.event-image');
        const button = card.querySelector('.event-content > .button');

        if (!description) return;

        if (!breakpoint.matches || !image || !button) {
          description.style.removeProperty('display');
          description.style.removeProperty('-webkit-line-clamp');
          return;
        }

        description.style.removeProperty('display');
        const lineHeight = parseFloat(getComputedStyle(description).lineHeight) || 24;
        const available = image.getBoundingClientRect().bottom
          - description.getBoundingClientRect().top
          - button.getBoundingClientRect().height;
        const lines = Math.floor(available / lineHeight);

        if (lines < 1) {
          description.style.display = 'none';
        } else {
          description.style.webkitLineClamp = String(lines);
        }
      });
    };

    const toggleSwiper = () => {
      if (breakpoint.matches) {
        destroySwiper();
      } else {
        enableSwiper();
      }
      clampDescriptions();
    };

    toggleSwiper();
    breakpoint.addEventListener('change', toggleSwiper);
    window.addEventListener('resize', debounce(clampDescriptions));
  });
}
